import { playdataSettingsQueryOptions } from "@data/public-page-data-query"
import PlaydataLayout from "@playdata/PlaydataLayout"
import { PlaydataSettingsProvider } from "@playdata/playdata-settings-context"
import type { SupportedLocale } from "@site-types/content"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"

export const Route = createFileRoute("/$locale/playdata")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: ({ context, params }) =>
    context.queryClient
      .ensureQueryData(playdataSettingsQueryOptions(params.locale as SupportedLocale))
      // Settings are a convenience, not a dependency: a failure here must not
      // take down every page beneath it, so the pages fall back instead.
      .catch(() => null),
  component: PlaydataRoute,
})

function PlaydataRoute() {
  const { locale } = Route.useParams()
  const settings = Route.useLoaderData()
  return (
    <PlaydataSettingsProvider settings={settings ?? null}>
      <PlaydataLayout locale={locale as SupportedLocale}>
        <Outlet />
      </PlaydataLayout>
    </PlaydataSettingsProvider>
  )
}
